const WalkerSitter = () => import(/* webpackPrefetch: true, webpackChunkName: "treatment-component" */ '@/app/views/main-view/walker-sitter/components/walker-sitter/walker-sitter.vue');

export default {
    name: 'WalkerSitterContainer',
    components: { WalkerSitter }
}